import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

export function useTranslateInboundEmail(conversationId: string | null) {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.inboundEmails.translateAndSave.mutationOptions({
      onSuccess: async () => {
        if (!conversationId) return;

        await queryClient.invalidateQueries({
          queryKey: orpc.communications.emailThreads.getThread.key({
            input: { conversationId },
          }),
        });
      },
    }),
  );
}
